import { render, staticRenderFns } from "./RekamMedisLabRadiologi.vue?vue&type=template&id=f6bd2920&scoped=true&"
import script from "./RekamMedisLabRadiologi.vue?vue&type=script&lang=ts&"
export * from "./RekamMedisLabRadiologi.vue?vue&type=script&lang=ts&"
import style0 from "./RekamMedisLabRadiologi.vue?vue&type=style&index=0&id=f6bd2920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bd2920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDivider,VRow,VTab,VTabItem,VTabs})
